import checkRequiredInputs from "./check-required-inputs";

const FormValidation = () => {
  const forms = [...document.querySelectorAll(".wpcf7-form")];

  if (forms.length > 0) {
    forms.forEach((form) => {
      const requiredInputs = [
        ...form.querySelectorAll('.wpcf7-validates-as-required'),
        ...form.querySelectorAll('input[type="checkbox"]')
      ];
      const submitBtn = form.querySelector(".wpcf7-submit");

      if (requiredInputs.length > 0) {
        requiredInputs.forEach(requiredInput => {
          requiredInput.addEventListener('input', () => checkRequiredInputs(requiredInputs, submitBtn));
        });
      };
    });
  } 
}

export default FormValidation;